<script lang="ts">
  import { slide } from "svelte/transition"
  import { ChevronDown, ChevronRight, Share, Download } from "lucide-svelte"
  import PostAlignmentResults from "./PostAlignmentResults.svelte"
  import html2pdf from "html2pdf.js"

  let props = $props()
  let alignment_test: AlignmentTestType = props.alignment_test

  let post_alignment_results_open = $state(
    alignment_test.status == "post_scoring_completed"
  )

  function viewResults() {
    window.open(
      `/alignment_test_results/${alignment_test.access_token}?result_type=post`,
      "Post-Alignment Results"
    )
  }

  function printResults() {
    let element = document.getElementById("post-alignment-results")
    let opt = {
      filename: "post-alignment-results.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" }
    }
    try {
      html2pdf().from(element).set(opt).save()
    } catch (error) {
      console.error(error)
    }
  }
</script>

<div
  class="flex justify-between items-center mt-5 border border-zinc-200 bg-white py-2"
>
  <button
    class="flex justify-between items-center gap-x-3 cursor-pointer"
    onclick={() => (post_alignment_results_open = !post_alignment_results_open)}
  >
    {#if post_alignment_results_open}
      <ChevronDown class="w-12 h-12 flex-none text-gray-400" />
    {:else}
      <ChevronRight class="w-12 h-12 flex-none text-gray-400" />
    {/if}
    <h3 class="text-xl md:text-3xl font-bold py-1">
      Your Post-Alignment Test Results
    </h3>
  </button>
  <div class="flex gap-x-1">
    <button
      class="bg-indigo-100 hover:bg-indigo-200 py-1 px-4 flex items-center justify-center border border-indigo-400 shadow rounded text-sm mr-2 text-indigo-700"
      onclick={viewResults}
      >View
      <Share class="w-5 h-5 text-indigo-500 ml-2" />
    </button>
    {#if post_alignment_results_open}
      <button
        class="bg-indigo-100 hover:bg-indigo-200 py-1 px-4 flex items-center justify-center border border-indigo-300 hover:shadow rounded text-sm mr-2 text-indigo-800"
        onclick={printResults}
        >Download PDF
        <Download class="w-5 h-5 text-indigo-700 ml-2" />
      </button>
    {/if}
  </div>
</div>
{#if post_alignment_results_open}
  <div transition:slide>
    <PostAlignmentResults {alignment_test} />
  </div>
{/if}
